import styled from 'styled-components';

export const CalculateTipBg = styled.div`
  display: flex;
  flex-direction: column;
  @media only screen and (min-width: 90em) {
    width: 50%;
  }
`;

export const BillLabel = styled.p`
  font-size: 1.6rem;
  text-transform: uppercase;
`;
